import './index.less';
import './console-header';
import { Game } from './components/Game/Game';
import * as App from './app';
import * as SDK from './lib/sdk';
import * as Backend from './backend-api';
import * as FEATURES from './app/const/features';
import { AssetsLoader } from './lib/classes';
import { disableContextmenu, disableUserScale } from './lib/utils';
import { onToggleTab } from './lib/utils/events';
import { MOVES_HISTORY_SIZE } from './app/const/game';
import { onError } from './lib/onError';
if (DEVELOPMENT && location.search.includes('promo')) {
    App.storage.upd({ maxScore: 250 });
}
App.init.metrika(function () {
    App.ab.start();
});
onError(function (params, args) {
    App.stat.params(params);
    setTimeout(function () {
        if (App.settings.get().sendErrorReport) {
            var payload = { message: args[0], file: args[1], line: args[2], args: args };
            App.Fn.sendMessage('😱 Ошибка!', payload, '#error').catch(function (err) {
                App.stat.error(err);
            });
        }
    }, 1000);
});
App.init.initTranslate();
App.settings.init().then(function () {
    var _a = App.settings.get(), useRemoteJS = _a.useRemoteJS, useRemoteCSS = _a.useRemoteCSS;
    var name = "".concat(PACKAGE_NAME, "-").concat(STORE);
    if (useRemoteJS)
        App.Fn.addRemoteJS(name);
    if (useRemoteCSS)
        App.Fn.addRemoteCSS(name);
    App.Fn.applyAdSettings(game);
});
if (FOR_VK) {
    App.Fn.syncBackend();
    if (DEVELOPMENT) {
        var params = new URLSearchParams(location.search);
        if (params.has('viewer_id') && !params.has('sign')) {
            var url = "/auth/as?externalId=".concat(params.get('viewer_id'), "&provider=vk");
            Backend.apiRequest(url, { method: 'GET' }).then(function () {
                location.replace("http://".concat(location.host));
            });
        }
    }
}
var rootEl = App.init.rootEl();
var viewPort = App.init.viewPort();
var game = new Game({
    viewPort: viewPort,
    historySize: MOVES_HISTORY_SIZE,
    useCoupBtn: App.settings.get().useCoupBtn,
});
function stopLearning() {
    rootEl.classList.remove('learning');
    game.stopLearn();
    game.reDraw();
}
SDK.Purchases.signed = true;
SDK.init(function () {
    App.Fn.syncAll(game, function () {
        setTimeout(function () { return App.Fn.updateBalance(); }, 1000);
        if (FOR_YANDEX) {
            App.Fn.consumeAllPurchases();
        }
        if (App.storage.get().learned) {
            stopLearning();
        }
    });
});
var progressBar = AssetsLoader.getInstance().el.valueOf();
progressBar.style.paddingTop = Math.floor(window.innerHeight / 3) + 'px';
rootEl.appendChild(progressBar);
Promise.all([AssetsLoader.getInstance().initPromise]).then(onLoadAssets);
function onLoadAssets() {
    progressBar && rootEl.removeChild(progressBar);
    rootEl.classList.remove('loading');
    App.Fn.applyAdSettings(game);
    game.mount(rootEl);
    SDK.ready();
    App.init.game({ game: game, endGameScreen: function () { return endGameScreen; }, leaderBoard: function () { return leaderBoard; } });
    var noMoneyAlert = App.init.noMoneyAlert({ storeModal: function () { return storeModal; } });
    noMoneyAlert.mount(rootEl);
    if (FEATURES.CANCEL_MOVE_FEATURE) {
        var cancelConfirm = App.init.cancelConfirm({ game: game, noMoneyAlert: function () { return noMoneyAlert; } });
        cancelConfirm.mount(rootEl);
    }
    if (FOR_YANDEX) {
        App.Fn.fixLeaderBoard(game);
    }
    var hintButton = App.init.initHintBtn(game, noMoneyAlert);
    var settingsModal = App.init.settingsModal({
        rootEl: rootEl,
        game: game,
        debugScreen: function () { return debugScreen; },
        leaderBoard: function () { return leaderBoard; },
        dailyBonusModal: function () { return dailyBonusModal; },
        startGame: function () { return startGame(); },
        updatePreviewOnStartScreen: function () { return updatePreviewOnStartScreen(); },
    });
    var settingsBtn = App.init.settingsBtn(game, settingsModal);
    settingsModal.mount(rootEl);
    App.emitter.on('loadUndoImg', function () { return game.reDraw(); });
    var debugScreen = App.init.initDebugScreen(rootEl);
    var leaderBoard = App.init.leaderBoard();
    leaderBoard.mount(rootEl);
    var topMenu = App.init.topMenu([settingsBtn, hintButton || null]);
    topMenu.mount(rootEl);
    if (DEVELOPMENT && location.search.includes('promo')) {
        setTimeout(function () { return topMenu.unmount(rootEl); }, 10 * 1000);
    }
    var dailyBonusModal = null;
    if (FEATURES.DAILY_BONUS_FEATURE) {
        dailyBonusModal = App.init.dailyBonusModal();
        dailyBonusModal.mount(rootEl);
    }
    var startScreen = App.init.startScreen({ viewPort: viewPort, rootEl: rootEl, game: game, dailyBonusModal: dailyBonusModal, startGame: startGame });
    var endGameScreen = App.init.endGameScreen({ cancelScreen: function () { return cancelScreen; }, startGame: startGame });
    endGameScreen.mount(rootEl);
    var alertScreen = App.init.alertScreen();
    alertScreen.mount(rootEl);
    var cancelScreen = App.init.cancelScreen({ game: game, alertScreen: alertScreen, startGame: startGame });
    if (cancelScreen)
        cancelScreen.mount(rootEl);
    function startGame() {
        game.newGame();
    }
    var storeModal = App.init.storeModal();
    storeModal.mount(rootEl);
    var coins = App.init.coinsBar(game, storeModal);
    coins.mount(rootEl);
    disableUserScale();
    disableContextmenu();
    if (!App.storage.get().learned) {
        game.learn(function () {
            stopLearning();
            App.storage.upd({ learned: true });
            game.newGame();
            SDK.Data.save('learned', true);
        });
        rootEl.classList.add('learning');
    }
    else {
        SDK.Data.save('learned', true); // TODO потом это нужно убрать
    }
    onToggleTab(function (visible) {
        if (visible) {
            game.reDraw();
            if (endGameScreen.opened) {
                endGameScreen.redraw(game.getPreview().canvas);
            }
            updatePreviewOnStartScreen();
        }
    });
    function updatePreviewOnStartScreen() {
        if (startScreen) {
            startScreen.setPreview(game.getPreview().canvas);
        }
    }
    if (PRODUCTION) {
        setTimeout(function () {
            var _a;
            return App.stat.params({ versions: (_a = {}, _a[PACKAGE_VERSION] = 1, _a) });
        }, 2500);
    }
    if (DEVELOPMENT) {
        App.init.initDevTools(rootEl, game, startScreen);
    }
    // jsErrs(PACKAGE_VERSION, METRIKA_COUNTER_ID)
}
if (DEVELOPMENT && FOR_YANDEX) {
    // @ts-ignore
    window['PACKAGE_NAME'] = PACKAGE_NAME;
}
